import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { CatalogSectionFamily } from "../../../models/CatalogSectionFamily";

type Props = {
	setSectionFamilyId: (id: number) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
};
export const useSectionOptionsFunctions = ({
	setSectionFamilyId,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: CatalogSectionFamily) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Section Family",
				key: "new_section_family",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Section Family",
					key: "edit_section_family",
					onClick: () => {
						setSectionFamilyId(data.SectionFamilyId!);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Section Family",
					key: "delete_section_family",
					onClick: () => {
						setSectionFamilyId(data.SectionFamilyId!);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
